const topicTags = [
  { label: '#吃瓜爆料', count: '12.8万', hot: true },
  { label: '#网址导航', count: '9.6万', hot: true },
  { label: '#618攻略', count: '8.3万', hot: true },
  { label: '#科技数码', count: '7.5万', hot: false },
  { label: '#追剧推荐', count: '6.8万', hot: true },
  { label: '#社会热点', count: '6.2万', hot: false },
  { label: '#游戏资讯', count: '5.7万', hot: false },
  { label: '#出行旅游', count: '4.9万', hot: false },
  { label: '#实用工具', count: '4.3万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">话题标签</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            当前最热门的话题标签，点击发现更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[800px] mx-auto">
          {topicTags.map((topic, i) => (
            <div
              key={i}
              className={`group relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100 text-accent-700'
                  : 'bg-background-50 border-background-200/70 hover:border-primary-200/60 text-foreground-700'
              }`}
            >
              {topic.hot && (
                <span className="absolute -top-1.5 -right-1.5 bg-accent-500 text-background-50 text-[9px] font-bold px-1.5 py-0.5 rounded-full">
                  HOT
                </span>
              )}
              <span className="text-sm font-medium">{topic.label}</span>
              <span className={`text-xs ${topic.hot ? 'text-accent-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}